import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';

const THEME_HEADER_CONFIG = 'themeHeaderConfig';
const TRANSLATION_KEY = 'mycredentials_navc_com.header';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  extraHeaderLinks: AccredibleResponsiveMenuItem[] = [
    {
      id: 'about',
      label: this._languageService.selectTranslate(TRANSLATION_KEY + '.about'),
      externalLink: 'https://navc.com/about-navc/',
    },
    {
      id: 'events',
      label: this._languageService.selectTranslate(TRANSLATION_KEY + '.events'),
      externalLink: 'https://navc.com/calendar/',
    },
    {
      id: 'resources',
      label: this._languageService.selectTranslate(TRANSLATION_KEY + '.resources'),
      externalLink: 'https://navc.com/',
    },
    {
      id: 'news',
      label: this._languageService.selectTranslate(TRANSLATION_KEY + '.news'),
      externalLink: 'https://navc.com/blog/',
    },
    {
      id: 'contact',
      label: this._languageService.selectTranslate(TRANSLATION_KEY + '.contact'),
      externalLink: 'https://navc.com/about-navc/contact-navc/',
    },
    {
      id: 'join',
      label: this._languageService.selectTranslate(TRANSLATION_KEY + '.join'),
      externalLink: 'https://navc.com/subscribe/',
    },
  ];

  constructor(private readonly _languageService: AccredibleLanguageService) {}
}
